module.exports = __webpack_public_path__ + "media/semantic/dist/themes/default/assets/fonts/outline-icons-89ffa3aba80d30ee0a9371b25c968bbb.svg";